module.exports = __webpack_public_path__ + "img/logo-header.6cbb8c02.png";